import React from 'react';
// import PropTypes from 'prop-types';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import {
  reasonForDecliningApplicationCTList,
  reasonForDecliningApplicationCUList,
} from 'config/data-lists/plannedNumberOfSitesList';
import { mapStateToProps } from 'utils/redux-decorators';
import { TextAreaField } from 'components/FormFields/TextAreaField';
import { Validation } from 'utils/forms/validations';
import { Button, CheckBoxGroupField } from 'components';
import { validate } from './validate';

const selector = formValueSelector('declineForm');

@mapStateToProps((state) => ({
  reasonFoDecliningApplication: selector(state, 'reasonFoDecliningApplication'),
}))
@reduxForm({
  form: 'declineForm',
  validate,
})
export class DeclineForm extends React.PureComponent {
  render() {
    const { handleSubmit, studyType, reasonFoDecliningApplication, hideModal } =
      this.props;
    const currentOther = studyType == 1 ? 9 : 13;

    let other = false;
    for (let i = 0; i < (reasonFoDecliningApplication || []).length; i++) {
      if (
        reasonFoDecliningApplication[i].key == currentOther &&
        reasonFoDecliningApplication[i].value === true
      ) {
        other = true;
      }
    }

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image mt-10 flex flex-column align-items-center justify-content-flex-end"
      >
        <Field
          name="reasonFoDecliningApplication"
          title="Reason for declining application"
          placeholder="Enter text"
          component={CheckBoxGroupField}
          data={
            studyType == 1
              ? reasonForDecliningApplicationCTList
              : reasonForDecliningApplicationCUList
          }
          checkboxContainerClassName="mb-3"
          fieldClassName="mb-10"
          columnsCount={1}
          onChange={this.changeCheckbox}
          gridRowGap="12px"
          isBottomErrorDisplay={false}
          isBackgroundErrorDisplay={true}
        />
        {other && (
          <Field
            name="other"
            description="Other (please specify)"
            lightDescription
            placeholder="Enter text"
            component={TextAreaField}
            maxLength={1000}
            validate={[Validation.required]}
          />
        )}
        <div
          className="flex align-items-center justify-content-flex-end mt-10"
          style={{ width: '100%' }}
        >
          <Button
            className="_simple-red mr-10"
            style={{ width: '180px' }}
            onClick={hideModal}
          >
            Cancel
          </Button>
          <Button type="submit" className="_red " style={{ width: '180px' }}>
            Request
          </Button>
        </div>
      </form>
    );
  }
}
